import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { SalesType } from '../models/sales-type.model';

@Injectable({
  providedIn: 'root'
})
export class SalesTypeService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readSalesTypes(): Observable<SalesType[]> {
    return this.#http.getData(`${this.baseUrl}/SalesType?status=true`, { showLoader: true, showMessage: false });
  }

  getSalesTypeById(id: string): Observable<SalesType> {
    return this.#http.getData(`${this.baseUrl}/SalesType/${id}`, { showLoader: true, showMessage: false });
  }
  createSalesType(salesType: SalesType): Observable<SalesType> {
    return this.#http.postData(`${this.baseUrl}/SalesType`, { showLoader: true, showMessage: true }, salesType);
  }
  updateSalesType(id: string, salesType: SalesType): Observable<SalesType> {
    return this.#http.putData(`${this.baseUrl}/SalesType/${id}`, salesType, { showLoader: true, showMessage: true });
  }
  deleteSalesType(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/SalesType/${id}`, { showLoader: true, showMessage: true });
  }
}
